import { defineStore } from "pinia";
import { createBaseStoreRefactor } from "./baseStoreRefactor";

// Define the base store configuration
const traitsBaseStore = createBaseStoreRefactor({
  endpoint: "/api/v1/traits",
  name: "TraitsStoreRefactor",
  objectName: "Trait",
  enableCache: true, // Enable 5-minute cache for traits
  actionCableChannel: null, // Traits don't need real-time updates
  infiniteLoading: false, // Simple list without pagination
});

export const useTraitsStoreRefactor = defineStore("traitsRefactor", {
  ...traitsBaseStore,

  state: () => ({
    ...traitsBaseStore.state(),
  }),

  getters: {
    ...traitsBaseStore.getters,

    // Backward compatibility getters
    getAllTraits: (state) => state.data,
    getTraitById: (state) => (id) =>
      state.data.find((trait) => trait.id === id),

    // Alias for backward compatibility
    traits: (state) => state.data,

    // Simple getters for trait styling
    getTraitIcon: (state) => (id) => {
      const trait = state.data.find((trait) => trait.id === id);
      return trait?.icon || "mdi-tag-outline";
    },

    getTraitColor: (state) => (id) => {
      const trait = state.data.find((trait) => trait.id === id);
      return trait?.color || undefined;
    },
  },

  actions: {
    ...traitsBaseStore.actions,
  },
});
